/*
 * FileName : content.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-09-09 10:52:13
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

// eslint-disable-next-line no-use-before-define
import React from 'react';
import { List, Input } from 'antd';
import Table from 'src/components/common/ResizableTable';
import { ColumnsType } from 'antd/es/table';
import './index.less';
export type ItemType = 'List' | 'Table';
import { useSelector } from 'react-redux';
import { LangMessage } from 'src/store/common/language';
export type DataItem = {
    label: string;
    value: string | number;
};
type Props<T> = {
    type: ItemType;
    data: T[];
    colunms?: ColumnsType<T>;
    key?: string;
    Mes: LangMessage;
};

const TerminalContent = <T extends Object = any>(props: Props<T>) => {
    const { type, data, colunms, key = 'key' } = props;
    const Mes = useSelector((state: any) => state.langSwitch.message);

    if (type === 'List') {
        return (
            <List
                size='large'
                className='terminal'
                dataSource={data as any[]}
                split={true}
                grid={{
                    column: 2,
                }}
                renderItem={(item, index) => (
                    <List.Item key={index}>
                        <span className='label' title={item.label}>
                            {item.label}:
                        </span>
                        {
                            item.key === 'status' ? (
                                <Input value={item.value === '1' ? Mes['titleTableStatusonlinestatusonline'] : Mes['titleTableStatusofflinestatusoffline']} style={{color: item.value === '1' ? '#22C55E' : 'red'}} disabled={true} />
                            ) : (
                                <Input value={item.value} disabled={true} />
                            )
                        }
                    </List.Item>
                )}
            />
        );
    }
    if (type === 'Table') {
        return (
            <Table
                columns={colunms as ColumnsType<T>}
                dataSource={data as T[]}
                rowKey={key}
                pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                    hideOnSinglePage: false,
                    position: [ 'bottomLeft' ],
                    size: 'default',
                    showTotal: (total: number) => `${Mes['titleLabelTotaltotal']} ${total} ${Mes['titleLabelItemsitems']}`,
                }}
            />);
    }
    return null;
};

export default TerminalContent;
